import { inject, Injectable } from "@angular/core";
import { HotToastService, ToastOptions } from "@ngxpert/hot-toast";

@Injectable({
  providedIn: "root",
})
export class ToasterService {
  hotToast = inject(HotToastService);

  constructor() {}

  success(title: string, message: string, options?: ToastOptions<any>) {
    this.hotToast.success(`<b>${title}</b><br/>${message}`, {
      className: "success-toaster",
      ...options,
    });
  }

  error(title: string, message: string, options?: ToastOptions<any>) {
    this.hotToast.error(`${title}.<br/>${message}`, {
      className: "error-toaster",
      ...options,
    });
  }

  warning(title: string, message: string, options?: ToastOptions<any>) {
    this.hotToast.warning(`${title}.<br/>${message}`, {
      className: "warning-toaster",
      ...options,
    });
  }

  info(title: string, message: string, options?: ToastOptions<any>) {
    this.hotToast.info(`${title}.<br/>${message}`, {
      className: "info-toaster",
      ...options,
    });
  }
}
